import { DatastoreProvider, InstanceDashboard } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { type RoutePath, useLocalSearchParams } from 'expo-router';
import { SkeletonDashboardScreen } from 'structure/admin/dashboard-loading-screen';
import { moderationDashModuleQuery } from 'system/structure-modules';

export function SuspenseFallback() {
    return <SkeletonDashboardScreen />;
}

export default function ModerationDashboardRootLayout() {
    const { siloKey } = useLocalSearchParams<Extract<RoutePath, `/[siloKey]/moderationdash/one/${string}`>>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'moderationdash',
        instanceKey: 'one',
        moduleQuery: moderationDashModuleQuery,
    });
    return (
        <DatastoreProvider {...instanceConfig} loadingScreen={<SkeletonDashboardScreen />}>
            <InstanceDashboard loadingScreen={<SkeletonDashboardScreen />} />
        </DatastoreProvider>
    );
}
